angular.module('cfn').directive('cfnInfluencesPayment', function() {
  return {
    restrict: 'E',
    templateUrl: require('./cfnInfluencesPayment.tpl.html'),
    link: function(scope, element, attrs) {
      var pricingCriterion = attrs.criterion;

      if (pricingCriterion) {
        var licensedCriterions = app.credentials.billedPricingCriteria;

        var isPricingCriterionAffectedByPrice =
          !!app.credentials.company.shopCountry &&
          licensedCriterions &&
          licensedCriterions.indexOf(pricingCriterion) > -1;

        scope.hideNotice = !isPricingCriterionAffectedByPrice;
      }
    }
  };
});
